// src/shared/constants/filterOptions.js
// Pre-built option arrays for table column filters.
// Reuses STATUS_META, PRIORITIES, etc. so there's a single source of truth.
import { STATUS_ORDER, STATUS_META } from './statuses';
import { PRIORITIES, PRIORITY_DOT_COLOR } from './priorities';

/** Status filter options — { value, label, color } */
export const STATUS_FILTER_OPTIONS = STATUS_ORDER.map(s => ({
  value: s,
  label: STATUS_META[s].label,
  color: STATUS_META[s].color,
}));

/** Priority filter options — { value, label, color } */
export const PRIORITY_FILTER_OPTIONS = Object.entries(PRIORITIES).map(([k, v]) => ({
  value: k,
  label: v.label,
  color: PRIORITY_DOT_COLOR[v.tone],
}));

/** Shared placeholder labels for filter dropdowns */
export const FILTER_PLACEHOLDER = {
  SELECT_CATEGORIES: 'Select category',
  SELECT_PRIORITIES: 'Select priority',
  SELECT_STATUSES: 'Select status',
  SELECT_ASSIGNEES: 'Select PICs',
};
export const FILTER_PLACEHOLDER_SELECT_DATE = 'Select date';
